export const SET_DEFAULT_SEARCH_VALUE = 'SET_DEFAULT_SEARCH_VALUE';
